import React, { useContext } from 'react';
import { useKitchenPause } from '../../lib/kitchen-pause-context';
/**
 * Global floating banner that appears when kitchen is paused.
 * Reads state from KitchenPauseContext — no props needed.
 * Place ONCE in App.tsx, it self-manages visibility.
 */
export function KitchenPausedBanner() {
  const {
    isKitchenPaused
  } = useKitchenPause();
  if (!isKitchenPaused) return null;
  return <div className="fixed top-0 left-0 right-0 z-[9999]" data-id="element-617">
      <div className="w-full bg-red-600 shadow-lg shadow-red-600/30" data-id="element-618">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-center gap-3" data-id="element-619">
          <span className="text-xl shrink-0" data-id="element-620">🔴</span>
          <div className="text-center" data-id="element-621">
            <p className="text-white font-bold text-sm sm:text-base leading-tight" data-id="element-622">
              Cocina Pausada — Estamos llenos
            </p>
            <p className="text-red-100 text-xs sm:text-sm leading-tight" data-id="element-623">
              No estamos recibiendo pedidos. Regresa en 10 minutos.
            </p>
          </div>
          <span className="text-xl shrink-0" data-id="element-624">🔴</span>
        </div>
      </div>
    </div>;
}